import { render, staticRenderFns } from "./ChartjsPie.html?vue&type=template&id=00fb24e6&external"
import script from "./ChartjsPie.js?vue&type=script&lang=js&external"
export * from "./ChartjsPie.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports